import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-184abc42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chart p-d-flex p-as-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chart__innerIcon p-as-center" }, null, -1))
const _hoisted_3 = { class: "p-mt-5" }
const _hoisted_4 = { class: "p-d-flex gap-lg p-flex-column p-mt-5 p-mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SkeletonIcon = _resolveComponent("SkeletonIcon")!
  const _component_SkeletonText = _resolveComponent("SkeletonText")!
  const _component_SkeletonMostVotedTag = _resolveComponent("SkeletonMostVotedTag")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "p-d-flex p-flex-column" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_SkeletonIcon, { class: "chart__icon p-as-center" }),
        _hoisted_2
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_SkeletonText, { length: 15 }),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (i) => {
            return _createVNode(_component_SkeletonMostVotedTag, { key: i })
          }), 64))
        ])
      ])
    ]),
    _: 1
  }))
}